const Messagingyourerrors = () => {
    return (
        <div className="LoadingpageContainer">
            <span class="loader"></span>
        </div>
    );
}
 
export default Messagingyourerrors;